import { render, staticRenderFns } from "./PercentChip.vue?vue&type=template&id=7d4b81a5&"
import script from "./PercentChip.vue?vue&type=script&lang=js&"
export * from "./PercentChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports